export default [
	{
		modulo: 0,
		privilegio: 27,
		routerName: 'voce',
		routerPath: '/voce',
		componentName: 'MenuPerfil',
		componentPath: 'modules/layout/perfil/main'
	}
]
